import {DivIcon, divIcon, Icon, icon} from 'leaflet';
import {renderToString} from 'react-dom/server';

import {LocalPackGridItemStatusEnum} from '../../../../../service/local-pack/local-pack-type';
import {getDaysBetween} from '../../../../../util/date';
import {LOCAL_PACK_NULL_POSITION_VALUE, LOCAL_PACK_RESULTS_RETENTION_DAYS} from '../../local-pack-const';
import {LocalPackAdvertisementResultIcon} from '../../local-pack-result-icon/local-pack-advertisement-result-icon';
import {LocalPackResultIcon} from '../../local-pack-result-icon/local-pack-result-icon';

import emptyIcon from './images/empty-results-icon.svg';
import failedIcon from './images/failed-icon.svg';
import newIcon from './images/new-icon.svg';
import {mapIconConfig} from './results-on-map-const';

function getIconForNewSearchResult(): Icon {
    return icon({
        ...mapIconConfig,
        iconUrl: newIcon,
    });
}

function getIconForEmptySearchResult(): Icon {
    return icon({
        ...mapIconConfig,
        iconUrl: emptyIcon,
    });
}

function getIconForFailedSearchResult(): Icon {
    return icon({
        ...mapIconConfig,
        iconUrl: failedIcon,
    });
}

function getIconForCompleteSearchResult(position: number, isCenter = false): DivIcon {
    return divIcon({
        ...mapIconConfig,
        className: '',
        html: renderToString(<LocalPackResultIcon isCenter={isCenter} position={position} />),
    });
}

function getIconForAdvertisement(): DivIcon {
    return divIcon({
        ...mapIconConfig,
        className: '',
        html: renderToString(<LocalPackAdvertisementResultIcon />),
    });
}

export function isLocalPackResultsOutdated(currentDate: string | null): boolean {
    if (!currentDate) {
        return false;
    }

    return getDaysBetween(new Date(currentDate), new Date()) > LOCAL_PACK_RESULTS_RETENTION_DAYS;
}

export function getMapIconConfig(options: {
    position: number | null;
    status?: LocalPackGridItemStatusEnum;
    isAdvertisement?: boolean;
    isCenter?: boolean;
    searchResultsCount?: number;
}): DivIcon | Icon {
    const {position, status, isCenter, isAdvertisement, searchResultsCount} = options;

    switch (true) {
        case isAdvertisement: {
            return getIconForAdvertisement();
        }
        case status === LocalPackGridItemStatusEnum.Complete && position === null && searchResultsCount === 1:
            return getIconForFailedSearchResult();
        case status === LocalPackGridItemStatusEnum.New:
            return getIconForNewSearchResult();
        case status === LocalPackGridItemStatusEnum.Complete:
            return getIconForCompleteSearchResult(position ?? LOCAL_PACK_NULL_POSITION_VALUE, isCenter);
        default: {
            return getIconForEmptySearchResult();
        }
    }
}
